export const getNotifications = state => state.notifications.list;
export const getDisplayStatus = state => state.notifications.display;